import React from 'react';
import OutPlannerConfirms from './OutPlannerConfirms';
import type { FormInstance } from '@bedrock/components/lib/Form/util';

export const renderActions = (detail: any, form: FormInstance) => {
  const { can_upload_invoice } = detail?.permission_info || {};
  
  if(!can_upload_invoice) return null;
  return <OutPlannerConfirms form={form} />
}
